import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { bool, string } from "prop-types";
import { Row, Col } from "react-bootstrap";
import { Form, withFormik, Field } from "formik";
import * as Yup from "yup";

import { selectors as investmentfundsSelectors, actions as investmentfundsActions } from "reducers/investmentfunds";

import * as i18n from "util/i18n";
import { emailRegex } from "util/form";

import Container from "pages/_components/Container";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import TextField from "pages/_components/fields/TextField";

class AccountsOfficerContact extends Component {
    static propTypes = {
        fetchingSubmit: bool.isRequired,
        idForm: string.isRequired,
        email: string.isRequired,
    };

    render() {
        const { fetchingSubmit, idForm, email } = this.props;

        return (
            <div className="container">
                <h2 className="title-content text-center">
                    <I18n id="investmentFunds.accountOfficer.title" />
                </h2>
                <div className="row">
                    <Form className="above-the-fold">
                        <Container className="container--layout flex-grow">
                            <Row className="gap-8">
                                <Col sm={12} md={8} mdOffset={2} className="form-group form-group--select">
                                    <Field
                                        component={TextField}
                                        idForm={idForm}
                                        name="subject"
                                        type="text"
                                        hidePlaceholder
                                    />
                                </Col>

                                <Col sm={12} md={8} mdOffset={2}>
                                    <Field
                                        component={TextField}
                                        idForm={idForm}
                                        name="to"
                                        type="text"
                                        hidePlaceholder
                                        value={email}
                                        disabled
                                    />
                                </Col>

                                <Col sm={12} md={8} mdOffset={2}>
                                    <Field
                                        component={TextField}
                                        idForm={idForm}
                                        name="from"
                                        type="text"
                                        hidePlaceholder
                                    />
                                </Col>

                                <Col sm={12} md={8} mdOffset={2}>
                                    <Field
                                        component={TextField}
                                        renderAs="textarea"
                                        name="body"
                                        idForm={idForm}
                                        hideLabel
                                        className="data-label"
                                        hidePlaceholder
                                        maxLength={256}
                                        hintLabel={i18n.get("", "Máximo de 256 caracteres.")}
                                    />
                                </Col>

                                <Col sm={12} md={8} mdOffset={2}>
                                    <Button
                                        type="submit"
                                        bsStyle="primary"
                                        label="investmentFunds.accountOfficer.send"
                                        loading={fetchingSubmit}
                                    />
                                </Col>
                            </Row>
                        </Container>
                    </Form>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => ({
    fetchingSubmit: investmentfundsSelectors.getFetchingSubmit(state),
});
export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: (props) => ({
            to: props.email ? props.email : "",
        }),
        validationSchema: () =>
            Yup.object().shape({
                subject: Yup.string().required(i18n.get("investmentFunds.accountOfficer.subject.empty")),
                from: Yup.string()
                    .required(i18n.get("investmentFunds.accountOfficer.from.empty"))
                    .test(
                        "format",
                        i18n.get("onboarding.step.verifyEmail.email.error.invalidFormat"),
                        (value) => !!value && emailRegex.test(value),
                    ),
                to: Yup.string().required(i18n.get("investmentFunds.accountOfficer.to.empty")),
                body: Yup.string().required(i18n.get("investmentFunds.accountOfficer.body.empty")),
            }),
        handleSubmit: (data, formikBag) => {
            const { dispatch, onClose, fetchingSubmit, email } = formikBag.props;
            const params = { subject: data.subject, body: data.body, from: data.from, to: data.to, formikBag };
            dispatch(investmentfundsActions.accountOfficerContact(params));

            if (!fetchingSubmit) {
                formikBag.resetForm({
                    subject: "",
                    from: "",
                    body: "",
                    to: email,
                });
                onClose();
            }
        },
    }),
)(AccountsOfficerContact);
